import React, { useState, useEffect } from "react";
import { Card, Form, Icon, Input, Button, Row } from 'antd';
import Auth from "../../../auth/Auth";
import { validForm } from "../../../functions/validForm";
import { openNotificationWithIcon } from "../../common/Notification";

function Login({props}){
    let [ user, setUser ] = useState({
        username: undefined,
        password: undefined
    });
    let [ loading, setLoading ]= useState(false);
    
    useEffect(() => {
        if(user.username === undefined || user.username === "") return;
        if(props.login.loading) return 

        if(user.username === "") return;
        Auth.login(props.login.data,(res) => {
            if(res === "SUCCESS"){
                openNotificationWithIcon('success', "Sucesso", "Bem vindo!", "", 4);
                setLoading(loading = true);
                setTimeout(() => {
                    setUser(user = {
                        username: undefined,
                        password: undefined,
                    })
                    setLoading(loading = false);
                    props.history.push("/dashboard")
                },3000)
            }else if(res === "ERROR"){
                openNotificationWithIcon(
                    'error', "Erro", 
                    "Usuario ou senha invalidos.", "", 5
                );
            }
        });
    }, [props.login])

    function login(){
        if(!validForm(user)){
            openNotificationWithIcon(
                'warning',"Aviso", 
                "Preencha todos os campos antes de continuar.",
                "",5
            );
            return 
        }

        const data = {
            username: user.username,
            password: user.password 
        };
        props.requestLogin(data);
    }

    function keyCode(evt){
        if(evt.keyCode === 13) login() 
    }

    return(
        <header className="v-header container">
            <div className="fullscreen-video-wrap">
                <img alt="" style={{width: "100%"}} src={require("../../../img/background.jpg")}/>
            </div>
            <div className="header-overlay"></div>
            <div className="App-header">
                <Card 
                    style={{ width: 400, height: 410, borderRadius: 45 }}
                    cover={
                        <img 
                            src={require("../../../img/logoAssistencia.png")} 
                            style={{ 
                                borderRadius: "20px", 
                                marginTop: 30, 
                                width: "90%", 
                                display: "block", 
                                marginLeft: "auto", 
                                marginRight: "auto"
                            }} 
                            alt="Logo" 
                        />
                    }
                    className="cardLogin"
                >
                    <Form 
                        //onSubmit={login} 
                        className="login-form"
                        style={{marginTop: 10}}
                    >
                        <Form.Item hasFeedback>
                            <Input 
                                onChange={(e) => setUser(user = {...user, username: e.target.value})} 
                                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} 
                                placeholder="Usuario" 
                            />
                        </Form.Item>

                        <Form.Item hasFeedback>
                            <Input.Password 
                                onChange={(e) => setUser(user = {...user, password: e.target.value})}
                                onKeyDown={(e) => keyCode(e)}
                                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} 
                                placeholder="Senha" 
                            />
                        </Form.Item>
                    </Form>

                    <Form.Item>
                        <Row>
                            <Button 
                                style={{ width: "100%" }} 
                                loading={loading} 
                                onClick={() => login()} 
                                type="primary" 
                                htmlType="submit"
                                className="login-form-button"
                            >
                                Continuar
                            </Button>
                        </Row>
                    </Form.Item>     
                </Card>   
            </div>
        </header>
    )
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/general/loginWrapper/Login.jsx